import './reclute.css';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import { useState, useEffect} from "react";
export const Reclute = () => {
const [openBody1, setOpenBody1] = useState<number>(1);
const [openBody2, setOpenBody2] = useState<number>(0);
const [openBody3, setOpenBody3] = useState<number>(0);

const openRecluetBody = (check: number) => {
  if (check === 1) {
    setOpenBody1(openBody1 === 1 ? 0 : 1);
  } else if (check === 2) {
    setOpenBody2(openBody2 === 1 ? 0 : 1);
  } else if (check === 3) {
    setOpenBody3(openBody3 === 1 ? 0 : 1);
  }
};

  return (
    <>
      <Header />
      <main>
        <div className='contents-title-box'>
          <h3>採用情報</h3>
        </div>
        <div>
          <p>会社を一緒に支えてくださる方募集</p>
        </div>
        <div className='reclute-container'>
          <div className='reclute-item-box'>
            <div className='reclute-item-title' onClick={()=>openRecluetBody(1)}>
              <h4 className='f-color-base'>職人採用/職人養成</h4>
              <img src='img/allow.png' />
            </div>
            {openBody1 === 1 ? 
              <div className='reclute-item-body'>
                <div className='reclute-item-body-text'>
                  <h5>業務内容</h5>
                  <p>弊社専属職人として革小物の製造をしてただきます。</p>
                  <p>どんな不安も一緒に相談しながら乗り越えていただける方を募集します。</p>
                </div>
                <div className='reclute-item-body-text'>
                  <h5>研修内容</h5>
                  <p>未経験でも安心の研修があります。</p>
                  <p>職人として独立するにあたって生産の基礎から学んで頂きます。</p>
                </div>
                <div className='reclute-item-body-text'>
                  <h5>研修場所</h5>
                  <p>本社または栃木営業所</p>
                </div>
                <div className='reclute-item-body-training'>
                  <div className='reclute-item-body-training-contents'>
                    <p className='f-color-base'>STEP 1</p>
                    <p>1ヶ月目 生産補助</p>
                    <p className='font-sm'>道具の使い方を身につける</p>
                  </div>
                  <div className='reclute-item-body-training-allow'/>
                  <div className='reclute-item-body-training-contents'>
                    <p className='f-color-base'>STEP 2</p>
                    <p>2ヶ月目 個別研修</p>
                    <p className='font-sm'>生産の段取り・技術を学ぶ</p>
                  </div>
                  <div className='reclute-item-body-training-allow'/>
                  <div className='reclute-item-body-training-contents'>
                    <p className='f-color-base'>STEP 3</p>
                    <p>3ヶ月目以降 時期をみて独立</p>
                    <p className='font-sm'>ミシンや道具の準備開始</p>
                  </div>
                </div>
              </div>
              : null
            }
          </div>
          <div className='reclute-item-box'>
            <div className='reclute-item-title' onClick={()=>openRecluetBody(2)}>
              <h4 className='f-color-base'>パート採用</h4>
              <img src='img/allow.png' />
            </div>
            {openBody2 === 1 ? 
              <div className='reclute-item-body'>
                <div className='reclute-item-body-text'>
                  <h5>業務内容</h5>
                  <p>弊社専属職人として革小物の製造をしてただきます。</p>
                  <p>どんな不安も一緒に相談しながら乗り越えていいただける方を募集します。</p>
                </div>
                <div className='reclute-item-body-text'>
                  <h5>勤務地</h5>
                  <p>本社または栃木営業所</p>
                </div>
                <div className='reclute-item-body-text'>
                  <h5>勤務時間</h5>
                  <p>9:00～18:00（応相談） ※1日実働5時間以上働ける方、週3日以上</p>
                </div>
                <div className='reclute-item-body-text'>
                  <h5>条件</h5>
                  <p>40歳位まで</p>
                  <p>車通勤が可能な方 ※栃木営業所の場合</p>
                  <p>ミシンの踏める方、手芸・洋裁が好きな方歓迎</p>
                </div>
              </div>
              : null
            }
          </div>
          <div className='reclute-item-box'>
            <div className='reclute-item-title' onClick={()=>openRecluetBody(3)}>
              <h4 className='f-color-base'>内職採用</h4>
              <img src='img/allow.png' />
            </div>  
            {openBody3 === 1 ?
              <div className='reclute-item-body'>
                <div className='reclute-item-body-text'>
                  <h5>業務内容</h5>
                  <p>ご自宅で糊付け等の簡単な作業をして頂きます。</p>
                  <p>慣れないうちは30分程度、営業所にて説明を受けてもらいます。</p>
                </div>
                <div className='reclute-item-body-text'>
                  <h5>勤務地</h5>
                  <p>本社または栃木営業所</p>
                </div>
                <div className='reclute-item-body-text'>
                  <h5>条件</h5>
                  <p>歩合制</p>
                  <p>車で荷物の持ち運びが可能な方 ※栃木営業所の場合</p>
                  <p>自分のペースで働きたい、主婦の方歓迎</p>
                </div>
              </div>
              : null
            }
          </div>
          
        </div>
      </main>
      <Footer />
    </>
  );
};
